

exports.__esModule = true;
exports.$GiveAtCheckoutModel = undefined;

var _squid = require('squid');

var $GiveAtCheckoutModel = exports.$GiveAtCheckoutModel = _squid.$Model.extend('$GiveAtCheckoutModel', {
    api: new _squid.$Api({
        uri: '/api/donation',
        postAttempts: 2
    })
});

angular.value("$GiveAtCheckoutModel", $GiveAtCheckoutModel);
_squid.$Model;

_squid.$Api;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-models/src/donation/index.js
// module id = ../node_modules/xo-models/src/donation/index.js
// module chunks = 0